import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { graphql, Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import moment from 'moment';
import { IoLogoLinkedin } from 'react-icons/io5';
import { FaFacebookF } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import {
  TwitterShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from 'react-share';

import SearchPost from '../components/SearchPost';
import TrendingNewsCard from '../components/TrendingNewsCard';
import {
  MainNewsContainer,
  NewsDetailContainer,
  PageHeading,
  SignUp,
  TrendingNewsContainer,
  SignUpTitle,
  AuthorTime,
  NewsSocial,
  Categoris,
  TagButtonGroup,
  PostContainer,
  TrendingNewsHeading,
  TrendingNews,
  ListWrapper,
} from '../styles/news.detail.template.styled';
import SEO from '../components/seo';
import { COUNT } from '../constant/count';
import PostAccordion from '../components/NewAccordion';

export const Head = (props) => {
  const policy = get(props, 'pageContext.policyData');
  const slug = get(props, 'pageContext.slug');

  const seoData = {
    title: get(policy, 'seo.title'),
    description: get(policy, 'seo.metaDesc'),
    image: get(policy, 'seo.opengraphImage.mediaItemUrl'),
    pageUrl: get(policy, 'seo.opengraphUrl'),
    slug: `/policies-and-actions/${slug}/`,
    canonicalUrl: get(policy, 'canonicalUrlField.canonicalUrl'),
  };

  return <SEO seoProps={seoData} />;
};

const PolicyDetail = (props) => {
  const [trendingList, setTrendingList] = useState([]);
  const policy = get(props, 'pageContext.policyData');
  const categories = get(props, 'data.allWpPolicyCategory.edges');
  const title = get(policy, 'title');
  const content = get(policy, 'content');
  const databaseId = get(policy, 'databaseId');
  const img = get(policy, 'featuredImage.node.mediaItemUrl');
  const imgTitle = get(policy, 'featuredImage.node.altText');
  const optimizeImage = get(policy, 'featuredImage.node.localFile');
  const authors = get(policy, 'policyPostsFields.policyAuthor');
  const relatedPolicyTags = get(policy, 'policyTags.nodes');
  const date = get(policy, 'date');
  const editedDate = moment(date).format('MMMM D, YYYY');
  const accordionData = get(policy, 'policyPostsFields.accordion');
  const postAccordionContent = get(
    policy,
    'policyPostsFields.postAccordionContent',
  );
  const accordionTitle = get(policy, 'policyPostsFields.accordionTitle');

  const relatedPosts = get(props, 'data.allWpPolicy.nodes');
  const url = props.location.href;

  const updatCounter = (DBId) => {
    fetch(`${process.env.GATSBY_API_URL}/pan/v1/policycountview/${DBId}`)
      .then((results) => {
        return results.json();
      })
      .then((data) => data);
  };

  const fetchTrendingList = () => {
    fetch(`${process.env.GATSBY_API_URL}/pan/v1/policycountview`)
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        const list =
          data.length > 0 &&
          data?.slice(0, COUNT['PolicyAction'])?.sort((a, b) => {
            return b.views - a.views;
          });
        //remove same post from trending list
        const newList = list
          .filter((item) => item.ID !== databaseId)
          ?.slice(0, 5);
        setTrendingList(newList);
      });
  };

  const twitterLinkShare = () => {
    const twitterClass = document.querySelectorAll(
      '.bctt-click-to-tweet .bctt-ctt-text a',
    );
    twitterClass.forEach((el) => {
      const element = document.createElement('img');
      element.setAttribute(
        'src',
        'https://dashboard.pandemicactionnetwork.org/wp-content/uploads/2024/02/twitter.png',
      );
      el.appendChild(element);
    });
  };

  useEffect(() => {
    updatCounter(policy.databaseId);
    fetchTrendingList();
    twitterLinkShare();
  }, []);

  const conversion = (postDate) => {
    const pstConversion = moment(postDate).add(8, 'hours').toLocaleString();

    return pstConversion.split('GMT')[0].concat('000z');
  };

  const currentTime = moment(new Date().toString());
  const nextTime = moment(conversion(date));

  const publishTime =
    moment(conversion(date)).fromNow() === 'a year ago'
      ? `More Than a Year Ago`
      : currentTime.diff(nextTime, 'year') === 1
      ? `More Than a Year Ago`
      : nextTime.fromNow();

  return (
    <div className='wrapper'>
      <NewsDetailContainer>
        <MainNewsContainer>
          <PageHeading>{title}</PageHeading>
          <ListWrapper>
            <AuthorTime
              capitalFlag={
                publishTime === 'More Than a Year Ago' ? 'none' : 'capitalize'
              }
            >
              <ul className='author-list'>
                <li>
                  {authors &&
                    Array.isArray(authors) &&
                    authors.map((value, index) => {
                      return (
                        <span key={index}>
                          <Link
                            to={`/author/${value.slug}/`}
                            className='author-name'
                            data-testid='author-name'
                            title={value.name}
                          >
                            {value.name}
                          </Link>
                          {index !== authors.length - 1 && `, `}
                        </span>
                      );
                    })}
                  {editedDate && (
                    <span
                      className={`${
                        authors?.length > 0 ? 'auth-divider' : ''
                      } auth-span`}
                    >
                      {editedDate}
                    </span>
                  )}
                </li>
              </ul>
            </AuthorTime>
            <NewsSocial className='policy-detail-social'>
              <li>
                <span>SHARE</span>
              </li>
              <li>
                <a href='https://twitter.com/' title='Twitter' rel='noreferrer'>
                  <TwitterShareButton
                    url={url}
                    quote={title}
                    aria-label='Twitter'
                  >
                    <FaXTwitter />
                  </TwitterShareButton>
                </a>
              </li>
              <li>
                <a
                  href='https://www.linkedin.com/'
                  title='LinkedIn'
                  rel='noreferrer'
                >
                  <LinkedinShareButton
                    url={url}
                    quote={title}
                    aria-label='LinkedIn'
                  >
                    <IoLogoLinkedin />
                  </LinkedinShareButton>
                </a>
              </li>
              <li>
                <a
                  href='https://www.facebook.com/'
                  title='Facebook'
                  rel='noreferrer'
                >
                  <FacebookShareButton
                    url={url}
                    quote={title}
                    aria-label='Facebook'
                  >
                    <FaFacebookF />
                  </FacebookShareButton>
                </a>
              </li>
            </NewsSocial>
          </ListWrapper>
          <figure className='post-image'>
            {optimizeImage ? (
              <GatsbyImage image={getImage(optimizeImage)} alt={imgTitle} />
            ) : (
              <img src={img} alt={imgTitle} />
            )}
          </figure>
          {/* Content */}
          <div
            className='content'
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {accordionData && (
            <div className='accordion-section'>
              <PostAccordion
                accordionData={accordionData}
                accordionTitle={accordionTitle}
              />
            </div>
          )}
          {postAccordionContent && (
            <div
              className='content post-accordion-content'
              dangerouslySetInnerHTML={{ __html: postAccordionContent }}
            />
          )}
          {relatedPolicyTags.length ? (
            <Categoris>
              <span>Related Tags</span>
              <TagButtonGroup className='related-tags-for-policy'>
                {relatedPolicyTags.length &&
                  relatedPolicyTags.map((tag, index) => (
                    <li key={index} className='tagBtn'>
                      <Link
                        to={`/policies-and-actions/tags/${tag.slug}/#tags-title`}
                        title={tag.name}
                      >
                        {tag.name}
                      </Link>
                    </li>
                  ))}
              </TagButtonGroup>
            </Categoris>
          ) : null}
          <PostContainer>
            {relatedPosts.length > 0 && <h4>Related Posts</h4>}
            <ul className='related-post related-for-policy'>
              {Array.isArray(relatedPosts) &&
                relatedPosts.length > 0 &&
                relatedPosts.map((post, index) => {
                  const imgSrc = get(post, 'featuredImage.node.mediaItemUrl');
                  const altText = get(post, 'featuredImage.node.title');
                  const postTitle = get(post, 'title');
                  const postDisc = get(post, 'content');
                  const postsFields = get(
                    post,
                    'policyPostsFields.policySubTitle',
                  );
                  const postTime = get(post, 'date');
                  const id = get(post, 'id');
                  const slug = get(post, 'slug');
                  const gatsbyImageUrl = get(
                    post,
                    'featuredImage.node.localFile',
                  );
                  return (
                    <li key={index} className='post'>
                      <SearchPost
                        imgSrc={imgSrc}
                        altText={altText}
                        postTitle={postTitle}
                        postDisc={postDisc}
                        postsFields={postsFields}
                        postTime={postTime}
                        id={id}
                        slug={slug}
                        noContent
                        type='policies-and-actions'
                        optimizeImage={gatsbyImageUrl}
                      />
                    </li>
                  );
                })}
            </ul>
          </PostContainer>
        </MainNewsContainer>
        <TrendingNewsContainer>
          <SignUp className='policy-act-detail'>
            <SignUpTitle>Sign Up for Our Newsletter</SignUpTitle>
            <Link
              to='http://eepurl.com/h935Pj'
              title='Sign up here'
              target='_blank'
              rel='noreferrer'
            >
              Sign Up Here
            </Link>
          </SignUp>
          <div className='category-btn-grp' id='category-btn-grp-policy'>
            <TrendingNewsHeading>Category</TrendingNewsHeading>
            <TagButtonGroup>
              {categories &&
                categories.map(({ node }, index) => (
                  <li key={index}>
                    <Link
                      to={`/policies-and-actions/${node.slug}/`}
                      secondary
                      title={node.name}
                    >
                      {node.name}
                    </Link>
                  </li>
                ))}
            </TagButtonGroup>
          </div>
          <div className='trending-section'>
            <TrendingNewsHeading>
              Trending Policies &#38; Actions
            </TrendingNewsHeading>
            <TrendingNews className='policy-trending-section'>
              {trendingList &&
                trendingList.map((news, index) => (
                  <li key={index}>
                    <TrendingNewsCard {...news} page='policy' />
                  </li>
                ))}
            </TrendingNews>
          </div>
        </TrendingNewsContainer>
      </NewsDetailContainer>
    </div>
  );
};

export default PolicyDetail;

export const PolicyQuery = graphql`
  query PolicyDetailQuery($slug: String!, $allTagsFromNode: [String!]) {
    allWpPolicy(
      filter: {
        policyTags: { nodes: { elemMatch: { name: { in: $allTagsFromNode } } } }
        slug: { ne: $slug }
      }
      limit: 2
      sort: { date: DESC }
    ) {
      nodes {
        id
        slug
        databaseId
        author {
          node {
            id
            name
            slug
          }
        }
        content
        title
        featuredImage {
          node {
            altText
            mediaItemUrl
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  width: 1366
                  height: 768
                  formats: WEBP
                )
              }
            }
          }
        }
        policyPostsFields {
          policySubTitle
          policyAuthor {
            name
            slug
          }
        }
        policyTags {
          nodes {
            name
            slug
          }
        }
      }
    }
    allWpPolicyCategory {
      edges {
        node {
          name
          slug
        }
      }
    }
    allWpPage(filter: { slug: { eq: "policies-and-actions" } }) {
      nodes {
        title
        id
        slug
        featuredImage {
          node {
            altText
            mediaItemUrl
          }
        }
      }
    }
  }
`;
